import { FILE_PREVIEW, FILE_UPLOAD } from '../lib/constants'
import uploadFile from '../api/uploadFile'
import getDatabase from '../api/getDatabaseHeaders'

export default (history, file, isModel, eventType = '') => dispatch => {
    isModel == true ? dispatch({ type: FILE_UPLOAD, isModel: true }) : dispatch({ type: FILE_UPLOAD, isModel: false })
    uploadFile(file)
        .then(data => {
            if (isModel) {
                getDatabase(eventType)
                    .then(response => {
                        dispatch({
                            type: 'GET_DATABASE',
                            headers: response.headers,
                            database: response,
                            dateReference: response.dateReference
                        })
                    })
                    .catch(err => {
                        console.error(" => err",err)
                    })
                dispatch({ type: 'UPLOAD_MODEL_TAB', uploadModalTab: isModel, ...data })
            } else {
                dispatch({ type: FILE_PREVIEW, uploadModalTab: isModel, ...data })
            }
        })
        .catch(e => {

            e.response.json().then(body => {                
                const message =  getMessageError(body)                
                dispatch({ type: 'UPLOAD_ERROR', message})
            })
        })
}

function getMessageError(body) {
    try {
        JSON.parse(body?.error)
        return body?.error
    } catch {
        return body?.message
    }
}
